<template>
  <div>
    <component :is="component" />
  </div>
</template>

<script>
import AdminControlsGroupsView from './GroupsView';
import AdminControlsPermissionsView from './PermissionsView';
import AdminControlsUsersView from './UsersView';
import AdminControlsRolesView from './RolesView';
import AdminControlsRoleLevelsView from './RoleLevelsView';
import AdminControlsDomainsView from './DomainsView';

export default {
  name: 'AdminBaseControlView',
  components: {
    AdminControlsGroupsView,
    AdminControlsPermissionsView,
    AdminControlsUsersView,
    AdminControlsRolesView,
    AdminControlsRoleLevelsView,
    AdminControlsDomainsView,
  },
  computed: {
    type: vm => {
      const allowedTabs = ['users', 'groups', 'permissions', 'roles', 'role-levels', 'domains'];
      const { type } = vm.$route.query;
      return type && allowedTabs.includes(type) ? type : 'users';
    },
    component: vm => `admin-controls-${vm.type}-view`,
  },
};
</script>
